import { ApiType } from "@gymflow/common";
import { LeadPostDTO } from "@gymflow/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { reportQueryKeys } from "../report";
import { leadQueryKeys } from "./leadQueryKeys";

export function useMutationEditLead({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      patchedFields,
    }: {
      id: number;
      patchedFields: Partial<LeadPostDTO>;
    }) => api.leadApi.update(id, patchedFields),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: leadQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: reportQueryKeys.lead() });
    },
  });
}
